import React, { useEffect, useState } from 'react';
import './RegisterForm.css';
import FormDiv from '../Common/FormInput';
import { supabase } from '../../supabase';

import Btn from '../Common/Btn';
import { useNavigate } from 'react-router-dom';

const RegisterForm = () => {

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        date: '',
        time: '',
        notes: ''
    })

    const handleChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };
    
    const handleRegisterSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {

            const { data: userData, error: userError } = await supabase
                .from('users')
                .insert([
                    { 
                        first_name: formData.firstName, 
                        last_name: formData.lastName, 
                        email: formData.email,
                        phone_no: formData.phone

                    }
                ])
                .select() 
                .single(); 

            if (userError) throw userError;

            const { error: bookingError } = await supabase
                .from('bookings')
                .insert([
                    {
                        user_id: userData.id, 
                        booking_date: formData.date,
                        booking_time: formData.time,
                        additional_notes: formData.notes,
                        status: 'pending' 
                    }
                ]);

            if (bookingError) throw bookingError;

            navigate('/thankyou');

        } catch (error) {
            console.error("Registration pipeline failed:", error);
            alert("Registration failed: " + error.message);
        } finally {
            setLoading(false);
        }
    };



    return ( <form className='RForm' onSubmit={handleRegisterSubmit}>
        <div className='FormGrid'>
            <FormDiv label="First Name" type="text" placeholder="Enter your first name" value={formData.firstName} onChange={(e) => handleChange('firstName', e.target.value)}/>
            <FormDiv label="Last Name" type="text" placeholder="Enter your last name" value={formData.lastName} onChange={(e) => handleChange('lastName', e.target.value)} />
            <FormDiv label="Email" type="email" placeholder="Enter your email address" value={formData.email} onChange={(e) => handleChange('email', e.target.value)}/>
            <FormDiv label="Phone Number" type="tel" placeholder="Enter your phone number" value={formData.phone} onChange={(e) => handleChange('phone', e.target.value)}/>
            <FormDiv label="Perferred Date" type="date"  value={formData.date} onChange={(e) => handleChange('date', e.target.value)}/>
            <FormDiv label="Perferred Time" type="time" value={formData.time} onChange={(e) => handleChange('time', e.target.value)}/>
        </div>

        <div className='FormDiv'>
            <label className='FormLabel'>Additional Notes</label>
            <textarea className='FormInputArea' placeholder='Any specific questions or requirments' value={formData.notes} onChange={(e) => handleChange('notes', e.target.value)}></textarea>
        </div>

        <button 
                type="submit" 
                className="FormBtn" // Styled using your existing global asset button rules
                disabled={loading}
                style={{ width: '100%', padding: '14px', marginTop: '20px', cursor: 'pointer' }}
            >
                {loading ? 'Processing Registration...' : 'Register Reservation'}
            </button>
    </form>
)};
 
export default RegisterForm;